import { z } from 'zod';
import { patientBalanceOf } from './consultation-fee-rule';
export const ORDER_LINE_TYPES = ['lab', 'radiology', 'procedure'];
export const ORDER_FULFILMENT = ['in_house', 'outside'];
export const ORDER_LINE_PRIORITY = ['routine', 'urgent', 'stat'];
export const ORDER_LINE_QUANTITY_MAX = 20;
export const ORDER_LINES_PAGE_DEFAULT = 20;
export const ORDER_LINES_PAGE_MAX = 50;
export const ORDER_LINE_REASON_MIN = 3;
export const ORDER_LINE_REASON_MAX = 400;
export const ORDER_LINE_BILLING = ['outside', 'not_billed', 'unpaid', 'paid'];
export function defaultFulfilment(inHouse) {
    return inHouse ? 'in_house' : 'outside';
}
export function resolveFulfilment(input) {
    if (input.admission) {
        if (input.requested === 'outside')
            return { refusal: 'admission_outside' };
        if (!input.inHouse)
            return { refusal: 'admission_not_in_house' };
        return { fulfilment: 'in_house', forced: false };
    }
    if (!input.inHouse)
        return { fulfilment: 'outside', forced: input.requested === 'in_house' };
    return { fulfilment: input.requested ?? 'in_house', forced: false };
}
const CLOSED_INVOICE = ['cancelled', 'refunded', 'void'];
export function invoiceLive(invoice) {
    return !CLOSED_INVOICE.includes(invoice.status);
}
export function invoiceSettled(invoice) {
    if (!invoice || !invoiceLive(invoice) || invoice.status === 'draft')
        return false;
    return patientBalanceOf(invoice) <= 0;
}
export function lineBilling(fulfilment, invoices) {
    if (fulfilment === 'outside')
        return 'outside';
    const live = invoices.filter(invoiceLive);
    if (live.length === 0)
        return 'not_billed';
    return live.every((invoice) => invoiceSettled(invoice)) ? 'paid' : 'unpaid';
}
export const LAB_LINE_PROGRESS = ['rejected', 'ordered', 'collected', 'received', 'in_process', 'resulted', 'verified', 'released'];
export const RADIOLOGY_LINE_PROGRESS = ['ordered', 'scheduled', 'arrived', 'scanned', 'reported', 'verified', 'released'];
export function lineProgress(statuses, progress) {
    if (statuses.length === 0)
        return 'ordered';
    const live = statuses.filter((status) => status !== 'cancelled');
    if (live.length === 0)
        return 'cancelled';
    const rank = (status) => {
        const index = progress.indexOf(status);
        return index < 0 ? progress.length : index;
    };
    return live.reduce((least, status) => (rank(status) < rank(least) ? status : least));
}
const reasonSchema = z.string().trim().min(ORDER_LINE_REASON_MIN).max(ORDER_LINE_REASON_MAX);
export const orderLinesQuerySchema = z
    .object({
    encounterId: z.string().uuid().optional(),
    admissionId: z.string().uuid().optional(),
    type: z.enum(ORDER_LINE_TYPES).optional(),
    cursor: z.string().uuid().optional(),
    limit: z.coerce.number().int().min(1).max(ORDER_LINES_PAGE_MAX).default(ORDER_LINES_PAGE_DEFAULT),
})
    .refine((value) => Boolean(value.encounterId) !== Boolean(value.admissionId), {
    path: ['encounterId'],
    message: 'Give the encounter or the admission, not both',
});
export const cancelOrderLineSchema = z.object({ reason: reasonSchema });
export const switchFulfilmentSchema = z.object({
    fulfilment: z.enum(ORDER_FULFILMENT),
    reason: reasonSchema,
});
export const orderLineQuantitySchema = z.number().int().min(1).max(ORDER_LINE_QUANTITY_MAX);
//# sourceMappingURL=order-lines.js.map